let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6cs5n")).then(() => parcelRequire('dg6OU'));